export const UPDATE_SELECTED_COLUMNS = 'UPDATE_SELECTED_COLUMNS'
export const FETCH_SELECTED_COLUMNS = 'FETCH_SELECTED_COLUMNS'
export const STORE_SELECTED_COLUMNS = 'STORE_SELECTED_COLUMNS'
export const FETCH_SELECTED_COLUMNS_WIDTH = 'FETCH_SELECTED_COLUMNS_WIDTH'
export const STORE_SELECTED_COLUMNS_WIDTH = 'STORE_SELECTED_COLUMNS_WIDTH'
export const UPDATE_SELECTED_COLUMNS_WIDTH = 'UPDATE_SELECTED_COLUMNS_WIDTH'

